
class TempCart {
  constructor(key = "temp_cart") {
    this.key = key;
    this.STOREFRONT_URL = "https://domain.com/api/2024-10/graphql.json";
    this.STOREFRONT_TOKEN = "931613ee48ce115a667c96941595cfaf";
    this.CART_CREATE_PRICING = `
      mutation cartCreate($lines: [CartLineInput!]!, $numLines: Int!, $country: CountryCode) 
      @inContext(country: $country) {
        cartCreate(input: { lines: $lines }) {
          cart {
            id
            checkoutUrl
            lines(first: $numLines) {
              edges {
                node {
                  id
                  quantity
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      product {
                        title
                      }
                    }
                  }
                  cost {
                    amountPerQuantity {
                      amount
                      currencyCode
                    }
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
  }

  clear() {
    this.cart = { items: [] };
  }

  createCartTemp(lines) {
    const variables = {
      lines,
      numLines: lines.length,
      country: window.theme.currentCountryCode,
    };
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: this.CART_CREATE_PRICING,
        variables: variables,
      }),
    };
    fetch(this.STOREFRONT_URL, config)
      .then((res) => res.json())
      .then((data) => {
        const cart = data.data.cartCreate.cart;
        const items = cart.lines.edges.map((edge) => {
          const node = edge.node;
          const discountTotal = node.discountAllocations.reduce(
            (sum, d) => sum + Number(d.discountedAmount.amount), 0);

          const item = {
            id: node.merchandise.id.split("/").pop(),
            title: node.merchandise.title,
            productTitle: node.merchandise.product.title,
            quantity: node.quantity,
            price: node.cost.amountPerQuantity.amount,
            currency: node.cost.amountPerQuantity.currencyCode,
            subtotal: node.cost.subtotalAmount.amount,
            discountPrice: node.cost.amountPerQuantity.amount - discountTotal,
            compareAt: node.cost.compareAtAmountPerQuantity?.amount || null,
          };

          const regular = item.price;
          const discount =
            item.discountPrice &&
              parseFloat(item.discountPrice) < parseFloat(Number(item.price))
              ? item.discountPrice
              : null;

          if (Number(discount) > 0) {
            this.renderToProductCards(discount, regular, item);
          }
        });
        this.cart.items = items;
      })
      .catch((e) => {
        document.querySelectorAll(".js-price-container").forEach((el) => {
          el.style.opacity = '1';
        });
      }).finally(() => {
        document.querySelectorAll(".js-price-container").forEach((el) => {
          el.style.opacity = '1';
        });
      });
  }

  renderToProductCards(discount, regular, item) {
    const gid = String(item.id);
    const numericId = gid.includes('/') ? gid.split('/').pop() : gid;

    // Product card component
    const product = document.querySelector(
      `.product-card[data-variant-id="${numericId}"]`
    );
    if (product) {
      const priceContainer = product.querySelector(".price");
      if (priceContainer) {
        this.updatePriceUI(priceContainer, discount, regular,);
      }
    }

    // product detail
    const detailInput = document.querySelector(
      `.product__info-container input[name="id"][value="${numericId}"]`
    );

    if (detailInput) {
      const priceContainer = detailInput
        .closest(".product__info-container")
        .querySelector(".price-wrapper .price");
      if (priceContainer) {
        this.updatePriceUI(priceContainer, discount, regular);
      }
    }
  }

  updatePriceUI(priceContainer, discount, regular) {
    let html = "";
    if (discount > 0) {
      html = `
        <div class="price__regular ">
          <dd>
            <span class="price-item price-item--regular" style="text-decoration: line-through;">
              ${this.formatMoney(regular)}
            </span>&nbsp;
            <span class="price-item price-item--regular">
              ${this.formatMoney(discount)}
            </span>
          </dd>
        </div>
        <div class="price__sale">
          <dd>
            <span class="price-item price-item--sale">${this.formatMoney(discount)}</span>
          </dd>
          <dd class="price__compare">  
            <span class="price-item price-item--regular" style="text-decoration: line-through;">
              ${this.formatMoney(regular)}
            </span>
          </dd>
        </div>`;
      priceContainer.innerHTML = html;
    }
  }

  formatMoney(amount) {
    const template = window.theme.moneyFormat || "${{amount}}";
    return template.replace("{{amount}}", parseFloat(amount).toFixed(2));
  }
}


document.addEventListener("DOMContentLoaded", () => {
  const tempCart = new TempCart();
  tempCart.clear();
  let lines = [];

  // product detail
  const productDetail = document.querySelector(".product__info-container");
  if (productDetail) {
    const variantId = productDetail.dataset.variantId;
    lines.push({
      merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
      quantity: 1,
    });
  }

  //  product cart 
  const productList = [...document.querySelectorAll("[data-variant-id]")]
  if (productList.length > 0) {
    const variantIds = productList.map(
      (el) => el.dataset.variantId
    );
    lines = variantIds.map((id) => ({
      merchandiseId: `gid://shopify/ProductVariant/${id}`,
      quantity: 1,
    }));
  }

  // slider products
  let called = false;
  window.addEventListener("scroll", () => {
    if (called) return;
    const container = document.querySelector('.products-slider__container');
    if (!container) return;
    const variantEls = container.querySelectorAll('[data-variant-id]');
    const variantIds = Array.from(variantEls).map(el => el.dataset.variantId);
    lines = variantIds.map((id) => ({
      merchandiseId: `gid://shopify/ProductVariant/${id}`,
      quantity: 1,
    }));
    tempCart.createCartTemp(lines);
    called = true;
  });

  // modal quick view 
  document.addEventListener("click", (e) => {
    const quickBtn = e.target.closest("[data-quick-add]");
    if (!quickBtn) return;
    setTimeout(() => {
      const modalId = quickBtn.getAttribute("data-quick-add");
      const modal = document.querySelector(`#QuickAdd-${modalId}`);
      if (!modal) return;

      const variantEl = modal.querySelector("[data-variant-modal]");
      if (variantEl) {
        const variantId = variantEl.dataset.variantModal;
        tempCart.createCartTemp([
          { merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity: 1 }
        ]);
      }
    }, 400);

  });

  // change variant
  let lastCall = 0;
  document.addEventListener("change", (e) => {
    if (e.target && e.target.name === "id") {
      const now = Date.now();
      if (now - lastCall < 100) return;
      lastCall = now;
      const variantId = e.target.value;
      if (variantId) {
        tempCart.createCartTemp([
          { merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity: 1 }
        ]);
      }
    }
  });

  if (lines.length > 0) {
    tempCart.createCartTemp(lines);
  }
});
